import A11yDialog from 'a11y-dialog'

const modalInstances:ModalInstance = {};

/**
 * Idea here is to read page URL, if the page URL have an anchor that contains
 * modal's ID then the modal is opened automaticly. This way we keep modal open even
 * in a case page reload.
 */
function openDialogFromAnchor() {
  const [domain, anchor] = window.location.href.split('#');
  const anchorPart = decodeURI( anchor );
  const dialog = modalInstances[ anchorPart ];

  if( dialog ) {
    dialog.show();
  }
}

/**
 * Initialize all modals on the document
 */
export default function modalInit() {

  const htmlElement = document.documentElement;
  const modalElements = document.querySelectorAll('.va-modal');

  modalElements.forEach( modalElement => {
    const modal = new A11yDialog( modalElement );

    //Scroll lock, prevent scrolling content below overlay
    modal.on('show', () => (htmlElement.style.overflowY = 'hidden'))
      .on('hide', () => (htmlElement.style.overflowY = ''))

    modalInstances[ decodeURI( modalElement.id ) ] = modal;
  });

  openDialogFromAnchor();
}

interface ModalInstance {
  [key:string]: A11yDialog
}
